export const AUDIENCES = [
  ["all", "All tenants"], ["property", "By property"], ["unit", "By unit"], ["single", "A single tenant"],
  ["active_leases", "Active leases only"], ["overdue_rent", "Overdue rent"],
  ["upcoming_movein", "Upcoming move-in"], ["upcoming_moveout", "Upcoming move-out"], ["maintenance", "Maintenance-affected"],
];
export const MESSAGE_TYPES = ["General Announcement", "Property Access Request", "Building Inspection Notice", "Repair Appointment Notice", "Maintenance Notice", "Utility Notice", "Rent Reminder", "Lease Renewal Notice", "Emergency Notice", "Move-In / Move-Out Instructions"];
export const PLACEHOLDERS = ["tenant_name", "property_address", "unit_number", "inspection_date", "appointment_date", "appointment_time", "technician_name", "maintenance_number", "rent_amount", "due_date", "service_type"];
export const VAR_FIELDS = ["appointment_date", "appointment_time", "technician_name", "service_type", "inspection_date", "maintenance_number", "due_date", "rent_amount"];
export const TRACK_STATUSES = ["Sent", "Delivered", "Tenant Confirmed", "Tenant Declined", "No Response", "Follow-up Needed", "Completed"];

export const statusTone = {
  Sent: "bg-blue-100 text-blue-800 dark:bg-blue-900/40", Delivered: "bg-cyan-100 text-cyan-800 dark:bg-cyan-900/40",
  "Tenant Confirmed": "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40", "Tenant Declined": "bg-red-100 text-red-800 dark:bg-red-900/40",
  "No Response": "bg-amber-100 text-amber-800 dark:bg-amber-900/40", "Follow-up Needed": "bg-orange-100 text-orange-800 dark:bg-orange-900/40",
  Completed: "bg-muted text-muted-foreground", Scheduled: "bg-violet-100 text-violet-800 dark:bg-violet-900/40", Failed: "bg-red-100 text-red-800 dark:bg-red-900/40",
};

export function Sel({ testid, value, onChange, options, disabled }) {
  return (
    <select value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={testid} disabled={disabled}
      className="w-full rounded-lg border border-border bg-background p-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary/30 disabled:opacity-50">
      {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
    </select>
  );
}

export function Fld({ label, children }) {
  return (<div><label className="text-xs font-medium text-muted-foreground mb-1 block">{label}</label>{children}</div>);
}
